import Plausible from 'plausible-tracker';
import type { ApiErrorModel } from './api';
import { PUBLIC_PLAUSIBLE_DOMAIN } from '$env/static/public';

export const plausible = Plausible({
  domain: PUBLIC_PLAUSIBLE_DOMAIN,
  trackLocalhost: false,
  apiHost: 'https://plausible.beewithfriends.pilleye.dev',
});

export const { trackEvent } = plausible;

export function errorProps(err: ApiErrorModel) {
  return {
    props: { code: err.code || '', message: err.message || '', type: err.type || '' },
  };
}
